module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_1.942e5e04.png";